(function () {
  'use strict';

  let angular = window.angular;

  EdgeAgentModalController.$inject = [
    '$scope',
    '$rootScope',
    'AppUtils',
    'Customer',
    'EdgeDeviceService',
    'EdgeAgentService',
    '$interval',
    '$state',
  ];

  angular.module('app').component('deviceEdgeAgentFormModal', {
    template:'<div><div class="modal-header"><button type="button" class="close" ng-click="ctrl.modalInstance.dismiss()"><i class="fas fa-times"></i></button> <span>{{:: ctrl.edgeAgent.id ? \'form.actions.update\' : \'form.actions.create\' | translate}}</span> <span translate>entities.edgeagent.modelName</span></div><div class="modal-body"><device-edge-agent-form edge-agent="ctrl.edgeAgent" names="ctrl.names" disable-template-selection="true"></device-edge-agent-form><div style="position: relative; height: 535px; overflow-y: auto; overflow-x: hidden"><edge-agent-json edge-agent="ctrl.edgeAgent" height="475"></edge-agent-json></div></div><div ng-if="ctrl.saveError" class="alert alert-warning text-center marginB0 marginT10">{{ctrl.saveError}}</div><div ng-if="ctrl.wasModified" class="alert alert-warning text-center marginB0 marginT10"><span translate>entities.edgeagent._messages.wasModified</span><div><button class="btn btn-default btn-xs" ng-click="ctrl.refresh()" translate>buttons.reload</button></div></div><div class="modal-footer"><button class="btn btn-default js-btn-step pull-left" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-disabled="ctrl.disableSave" ng-click="ctrl.validateAndSave()" translate>buttons.save</button></div></div><spinner css-class="\'small\'" show-logo="true" show="ctrl.saving"></spinner>',
    controller: EdgeAgentModalController,
    controllerAs: 'ctrl',
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function EdgeAgentModalController(
    $scope,
    $root,
    utils,
    Customer,
    EdgeDeviceService,
    EdgeAgentService,
    $interval,
    $state
  ) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.device = vm.resolve.device;

      vm.edgeAgent = angular.copy(vm.resolve.edgeAgent || { enabled: true });
      vm.originalAgentSnapshot = EdgeAgentService.createAgentSnapshot(vm.edgeAgent);
      vm.names = vm.resolve.names;
      vm.refresh = refresh;
      vm.validateAndSave = applyChanges;

      $root.$on('ds:agent-generated-error', (e, error) => {
        vm.disableSave = !!error;
      });

      if (vm.originalAgentSnapshot) {
        vm.modifiedChecker = $interval(() => {
          checkModified().then((wasModified) => {
            vm.wasModified = wasModified;
          });
        }, 5000);
      }
    };

    vm.$onDestroy = function onDestroy() {
      if (vm.modifiedChecker) {
        $interval.cancel(vm.modifiedChecker);
      }
    };

    function checkModified() {
      if (!vm.originalAgentSnapshot) {
        return utils.Promise.resolve(false);
      }

      return Customer.prototype$__get__devices__edgeAgents({
        id: vm.device.customerId,
        nk: vm.device.id,
        filter: {
          where: { id: vm.originalAgentSnapshot.id },
          fields: EdgeAgentService.getModifiedCheckFields(),
        },
      })
        .$promise.then((result) => {
          const agent = (result || []).find(
            (current) => current.id === vm.originalAgentSnapshot.id
          );
          return EdgeAgentService.wasAgentModified(agent, vm.originalAgentSnapshot);
        })
        .catch(() => {
          return false;
        });
    }

    function validateGeneral() {
      return utils.Promise((resolve, reject) => {
        const offResponse = $root.$on('ds:agent-validate-after', (e, response) => {
          offResponse();
          resolve(response.valid);
        });
        $scope.$broadcast('ds:agent-validate');
      });
    }

    function validateAgentContent() {
      return utils.Promise((resolve, reject) => {
        const offResponse = $root.$on('ds:agent-validate-content-after', (e, response) => {
          offResponse();
          resolve(response);
        });
        $scope.$broadcast('ds:agent-validate-content');
      });
    }

    function refresh() {
      $state.reload();
    }

    function applyChanges() {
      vm.saving = true;
      checkModified()
        .then((wasModified) => {
          if (wasModified) {
            throw new Error('MODIFIED_AGENT');
          }

          return validateGeneral();
        })
        .then((valid) => {
          if (!valid) {
            throw new Error('INVALID AGENT');
          }
          return validateAgentContent();
        })
        .then((result) => {
          if (!result.valid) {
            throw new Error('INVALID AGENT CONTENT');
          }

          const agent = EdgeAgentService.getAgentBody(result.edgeAgent);
          agent.name = vm.edgeAgent.name;
          agent.sharedPath = vm.edgeAgent.sharedPath;
          agent.image = vm.edgeAgent.image.name + ':' + vm.edgeAgent.image.version;
          agent.enabled = vm.edgeAgent.enabled;

          if (!vm.edgeAgent.id) {
            return Customer.prototype$__create__devices__edgeAgents(
              {
                id: vm.device.customerId,
                nk: vm.device.id,
              },
              agent
            ).$promise;
          } else {
            return Customer.prototype$__updateById__devices__edgeAgents(
              {
                id: vm.device.customerId,
                nk: vm.device.id,
                fk: vm.edgeAgent.id,
              },
              agent
            ).$promise;
          }
        })
        .then((result) => {
          return EdgeDeviceService.loadEdgeAgents(vm.device.customerId, vm.device.id);
        })
        .then(function (agents) {
          vm.saving = false;
          vm.modalInstance.close(agents);
        })
        .catch(function (err) {
          vm.saving = false;
          if (err.message === 'MODIFIED_AGENT') {
            vm.wasModified = true;
            return;
          }

          vm.saveError = utils.getHTTPError(err);
        });
    }
  }
})();
